<!-- components/events/yuka/YukaClassIntro.svelte -->
<script>
  import { t } from "../../../libs/i18n";

  const yukaClassIntroSrc = `assets/img/yukaEvent/yuka-for-class-intro.png`;

</script>


<!-- ======= YukaClassIntro Section ======= -->
<section class="yuka-class-intro">
  <div class="container">
    <div class="row content">
      <div class="col-lg-12 p-4 new-content-intro">
        <div class="col-sm-12 col-md-6 col-lg-6 offset-3 mb-3 new-contens-info-block">
          <h1 class="new-content-title">{$t("yukaEvent.yukaClassIntroTitle")}</h1>
        </div>
      </div>
      <div class="row yuka-info-block">
        <div class="col-sm-12 col-md-6 col-lg-6 d-flex justify-content-center align-items-center mb-5">
            <div class="level-image-right">
              <img class="about-image yuka-for-class-intro-img" src={yukaClassIntroSrc} alt="level up">
            </div>        
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
          <p class="yuka-class-intro-description gray-text"><span class="yellow-txt">➤</span> {$t("yukaEvent.yukaClassDescription_1")}</p>
          <p class="yuka-class-intro-description gray-text"><span class="yellow-txt">➤</span> {$t("yukaEvent.yukaClassDescription_2")}</p>
          <p class="yuka-class-intro-description gray-text"><span class="yellow-txt">➤</span> {$t("yukaEvent.yukaClassDescription_3")}</p>
          <p class="yuka-class-intro-description gray-text"><span class="yellow-txt">➤</span> {$t("yukaEvent.yukaClassDescription_4")}</p>
          <p class="yuka-class-intro-description gray-text"><span class="yellow-txt">➤</span> {$t("yukaEvent.yukaClassDescription_5")}</p>
          <p class="yuka-class-intro-description gray-text"><span class="yellow-txt">➤</span> {$t("yukaEvent.yukaClassDescription_6")}</p>
        </div>
    
      </div>
    </div>
  </div>
</section><!-- End YukaClassIntro Section -->